import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { analyticsTrack } from '../../../analyticsUtils';
import { putRequest, deleteRequest } from '../../../requestUtils';
import { listElementsToArray } from '../../../responsibilitiesUtils';
import capitalize from '../../../stringUtils';
import '../ProjectDetails.scss';
import './ProjectReview.scss';
import AddCoworkersModal from '../../AddCoworkersModal';
import ProjectLoadingIndicator from '../ProjectLoadingIndicator';
import FeaturedProfileBanner from '../FeaturedProfileBanner/FeaturedProfileBanner';
import AdminModal from '../AdminModal';
import ProjectDetailsNav from '../ProjectDetailsNav';
function InfoRow(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    value = _ref.value;
  return /*#__PURE__*/React.createElement("div", {
    className: "ps-info-row"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa ".concat(icon)
  }), /*#__PURE__*/React.createElement("div", {
    className: "ps-info-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "ps-info-divider"
  }, "\xB7"), /*#__PURE__*/React.createElement("div", {
    className: "ps-info-value"
  }, value || 'N/A'));
}
var formStep = 'review';
var processTakeRate = function processTakeRate(takeRate) {
  if (!takeRate) return 25.0;
  return Math.round(takeRate * 10000) / 100;
};
var ProjectReview = /*#__PURE__*/function (_Component) {
  function ProjectReview(props) {
    var _this;
    _classCallCheck(this, ProjectReview);
    _this = _callSuper(this, ProjectReview, [props]);
    _this.state = {
      errors: [],
      projectDetails: null,
      teamModalViewed: false,
      pageSubmitted: false,
      openTeamModal: false,
      adminModalOpen: false,
      loading: false,
      showConfirmDeletion: false
    };
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleSaveDraft = _this.handleSaveDraft.bind(_this);
    _this.handleDeleteProject = _this.handleDeleteProject.bind(_this);
    _this.updateProjectDetails = _this.updateProjectDetails.bind(_this);
    _this.handleExit = _this.handleExit.bind(_this);
    _this.handleAfterPublish = _this.handleAfterPublish.bind(_this);
    return _this;
  }
  _inherits(ProjectReview, _Component);
  return _createClass(ProjectReview, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var projectResourceId = this.props.projectResourceId;
      if (!projectResourceId) return;
      this.updateProjectDetails();
    }
  }, {
    key: "updateProjectDetails",
    value: function updateProjectDetails() {
      var _this2 = this;
      var getProjectDetails = this.props.getProjectDetails;
      getProjectDetails(formStep).then(function (response) {
        _this2.setState({
          projectDetails: response.data,
          teamModalViewed: response.data.initial_team_members.team_members.length !== 1
        });
      });
    }
  }, {
    key: "isProjectDraft",
    value: function isProjectDraft() {
      return this.state.projectDetails.status === 'employer_draft';
    }
  }, {
    key: "handleSaveDraft",
    value: function handleSaveDraft() {
      this.setState({
        loading: true
      });
      window.location.href = this.state.projectDetails.save_draft_path;
    }
  }, {
    key: "handleDeleteProject",
    value: function handleDeleteProject() {
      var _this3 = this;
      var deleteProjectPath = this.state.projectDetails.delete_project_path;
      var projectIndexPath = this.state.projectDetails.project_index_path;
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        steps = _this$props.steps,
        userId = _this$props.userId;
      analyticsTrack('Project deleted from review page', {
        location: 'Project creation',
        eventId: 'Delete project from review',
        eventType: 'buttonClick',
        timestamp: Date.now(),
        buttonId: 'review-page-delete-project',
        buttonLabel: 'Delete Project',
        wizardStep: steps.length,
        wizardTotalSteps: steps.length,
        userId: userId
      });
      deleteRequest(deleteProjectPath, csrfToken).then(function () {
        _this3.setState({
          loading: true
        });
        window.location.href = projectIndexPath;
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this4 = this;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        projectResourceId = _this$props2.projectResourceId,
        steps = _this$props2.steps,
        userId = _this$props2.userId;
      if (this.isProjectDraft()) {
        putRequest("/projects/".concat(projectResourceId, "/publish"), {
          resource_id: projectResourceId
        }, csrfToken).then(function () {
          analyticsTrack('Project submitted to Clora from review page', {
            location: 'Project creation',
            eventId: 'Submit from review',
            eventType: 'buttonClick',
            timestamp: Date.now(),
            buttonId: 'review-page-submit',
            buttonLabel: 'Submit Project',
            wizardStep: steps.length,
            wizardTotalSteps: steps.length,
            userId: userId
          });
          _this4.setState({
            pageSubmitted: true
          }, _this4.handleAfterPublish);
        })["catch"](function (error) {
          window.location.href = '#';
          _this4.setState({
            errors: error
          });
        });
      } else {
        putRequest("/projects/".concat(projectResourceId), {
          resource_id: projectResourceId
        }, csrfToken)["catch"](function (error) {
          window.location.href = '#';
          _this4.setState({
            errors: error
          });
        });
        window.location.href = "/projects/".concat(projectResourceId);
      }
    }
  }, {
    key: "handleAfterPublish",
    value: function handleAfterPublish() {
      var projectResourceId = this.props.projectResourceId;
      var _this$state = this.state,
        pageSubmitted = _this$state.pageSubmitted,
        teamModalViewed = _this$state.teamModalViewed;
      var projectShowUrl = "/projects/".concat(projectResourceId);
      if (pageSubmitted && teamModalViewed) {
        window.location.href = projectShowUrl;
      } else if (pageSubmitted) {
        this.setState({
          openTeamModal: true
        });
      }
    }
  }, {
    key: "handleExit",
    value: function handleExit() {
      var projectResourceId = this.props.projectResourceId;
      if (this.isProjectDraft()) {
        this.handleSaveDraft();
      } else {
        window.location.href = "/projects/".concat(projectResourceId);
      }
    }
  }, {
    key: "travelLocationText",
    value: function travelLocationText() {
      var projectDetails = this.state.projectDetails;
      var location = projectDetails.travel_locations && projectDetails.travel_locations[0];
      if (projectDetails.travel_time === 'travel' && location) {
        return location;
      }
      return null;
    }
  }, {
    key: "hoursText",
    value: function hoursText() {
      var projectDetails = this.state.projectDetails;
      if (!projectDetails.avg_time_required_range || projectDetails.avg_time_required_range === 'not sure') return null;
      return projectDetails.avg_time_required_text || "".concat(projectDetails.avg_time_required_range, " hours per week");
    }
  }, {
    key: "durationText",
    value: function durationText() {
      var projectDetails = this.state.projectDetails;
      if (!projectDetails.duration_range || projectDetails.duration_range === 'not sure') return null;
      if (projectDetails.duration_text) return "".concat(projectDetails.duration_text, " duration");
      var n = parseInt(projectDetails.duration_range, 10);
      return "".concat(projectDetails.duration_range, " ").concat(n === 1 ? 'month' : 'months', " duration");
    }
  }, {
    key: "officeLocationText",
    value: function officeLocationText() {
      var projectDetails = this.state.projectDetails;
      switch (projectDetails.work_location) {
        case 'office':
          return "At least ".concat(projectDetails.office_days, " days in the office (").concat(projectDetails.office_location, ")");
        case 'remote':
          return 'Remote';
        case 'hybrid':
          {
            var loc = 'Hybrid';
            if (projectDetails.office_days) loc += ", in office ".concat(projectDetails.office_days, " days/week");
            if (projectDetails.office_location) loc += " at ".concat(projectDetails.office_location);
            return loc;
          }
        case 'both':
          return "Office and remote. At least ".concat(projectDetails.office_days, " days in the office (").concat(projectDetails.office_location, ").");
        case 'not sure':
          return 'Workplace Preference';
        default:
          return 'Work preference';
      }
    }
  }, {
    key: "sectionWarningText",
    value: function sectionWarningText(section) {
      var steps = this.props.steps;
      var projectDetails = this.state.projectDetails;
      if (!projectDetails.abandoned_at) return null;

      // Map backend abandoned_at values to the frontend step names used in `steps`
      var abandonedAtStepMap = {
        budget: 'budget & logistics',
        logistics: 'budget & logistics',
        responsibilities: 'description',
        scope: 'description'
      };

      // Map the warnSection labels (passed to renderSection) to frontend step names
      var sectionStepMap = {
        start: 'start',
        responsibilities: 'description',
        qualifications: 'qualifications',
        'budget & logistics': 'budget & logistics'
      };
      if (projectDetails.abandoned_at === 'budget' || projectDetails.abandoned_at === 'logistics') {
        if (section === 'Budget & Logistics' && (!projectDetails.work_location || !projectDetails.travel_time || !projectDetails.budget_minimum || !projectDetails.budget_maximum)) {
          return 'Please complete section';
        }
        return null;
      }
      var abandonedStep = abandonedAtStepMap[projectDetails.abandoned_at] || projectDetails.abandoned_at;
      var sectionStep = sectionStepMap[section.toLowerCase()] || section.toLowerCase();
      var abandonedIdx = steps.indexOf(abandonedStep);
      var sectionIdx = steps.indexOf(sectionStep);
      if (sectionIdx === abandonedIdx) return 'Please complete section';
      if (sectionIdx > abandonedIdx) return 'Please complete previous section';
      return null;
    }
  }, {
    key: "renderEditLink",
    value: function renderEditLink(section) {
      var redirectToReview = this.state.projectDetails.abandoned_at === null;
      return /*#__PURE__*/React.createElement("a", {
        role: "link",
        tabIndex: 0,
        onClick: this.props.handleUpdateSection(section, redirectToReview),
        className: "review-section-edit-link"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-edit"
      }), "Edit");
    }
  }, {
    key: "renderSubmit",
    value: function renderSubmit() {
      var btnClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var projectDetails = this.state.projectDetails;
      var disabledState = false;
      if (projectDetails.abandoned_at === 'budget' || projectDetails.abandoned_at === 'logistics') {
        disabledState = !projectDetails.work_location || !projectDetails.travel_time || !projectDetails.budget_minimum || !projectDetails.budget_maximum;
      } else {
        disabledState = !!projectDetails.abandoned_at;
      }
      var buttonText = this.isProjectDraft() ? 'Submit Project' : 'Save';
      return /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary text-white button-submit ".concat(btnClass),
        onClick: this.handleSubmit,
        disabled: disabledState
      }, buttonText);
    }
  }, {
    key: "renderSection",
    value: function renderSection(title, content, editTarget) {
      var _this5 = this;
      var warnSection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var onEdit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var warningText = warnSection ? this.sectionWarningText(warnSection) : null;
      var editEl = function () {
        if (onEdit) {
          return /*#__PURE__*/React.createElement("button", {
            type: "button",
            onClick: onEdit,
            className: "review-section-edit-link"
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-edit"
          }), "Edit");
        }
        if (editTarget) return _this5.renderEditLink(editTarget);
        return null;
      }();
      return /*#__PURE__*/React.createElement("div", {
        className: "review-section-card",
        key: "section-".concat(title)
      }, /*#__PURE__*/React.createElement("div", {
        className: "review-section-header"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "review-section-title"
      }, title), editEl), warningText && /*#__PURE__*/React.createElement("div", {
        className: "review-section-warning-bar"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle"
      }), warningText), /*#__PURE__*/React.createElement("div", {
        className: "review-section-body"
      }, content));
    }
  }, {
    key: "renderJobTitleContent",
    value: function renderJobTitleContent() {
      var projectDetails = this.state.projectDetails;
      var seniority = projectDetails.seniority,
        roles = projectDetails.higher_level_roles;
      return /*#__PURE__*/React.createElement("div", {
        className: "ps-info-list"
      }, /*#__PURE__*/React.createElement(InfoRow, {
        icon: "fa-briefcase",
        label: "Job Title",
        value: projectDetails.name
      }), /*#__PURE__*/React.createElement(InfoRow, {
        icon: "fa-id-badge",
        label: "Role",
        value: roles && roles.length > 0 ? roles.join(', ') : null
      }), /*#__PURE__*/React.createElement(InfoRow, {
        icon: "fa-certificate",
        label: "Seniority",
        value: seniority && seniority.length > 0 ? seniority.join(', ') : null
      }), /*#__PURE__*/React.createElement(InfoRow, {
        icon: "fa-user-tie",
        label: "Employment Type",
        value: capitalize(projectDetails.employment_type)
      }));
    }
  }, {
    key: "renderEngagementContent",
    value: function renderEngagementContent() {
      return /*#__PURE__*/React.createElement("div", {
        className: "ps-info-list"
      }, /*#__PURE__*/React.createElement(InfoRow, {
        icon: "fa-calendar-alt",
        label: "Duration",
        value: this.durationText()
      }), /*#__PURE__*/React.createElement(InfoRow, {
        icon: "fa-clock",
        label: "Hours per week",
        value: this.hoursText()
      }));
    }
  }, {
    key: "renderAboutContent",
    value: function renderAboutContent() {
      var projectDetails = this.state.projectDetails;
      return /*#__PURE__*/React.createElement("div", {
        className: "about"
      }, /*#__PURE__*/React.createElement("span", null, projectDetails.description || ''));
    }
  }, {
    key: "renderIdealCandidateContent",
    value: function renderIdealCandidateContent() {
      var projectDetails = this.state.projectDetails;
      var items = listElementsToArray(projectDetails.ideal_candidate_description);
      if (items.length === 0) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-ideal-candidate"
      }, /*#__PURE__*/React.createElement("ul", null, items.map(function (text) {
        return /*#__PURE__*/React.createElement("li", {
          key: text
        }, text);
      })));
    }
  }, {
    key: "renderResponsibilitiesContent",
    value: function renderResponsibilitiesContent() {
      var responsibilities = this.state.projectDetails.responsibility_areas;
      if (!responsibilities || responsibilities.length === 0) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-responsibilities"
      }, /*#__PURE__*/React.createElement("ul", null, responsibilities.map(function (text) {
        return /*#__PURE__*/React.createElement("li", {
          key: text
        }, text);
      })));
    }
  }, {
    key: "renderQualificationsContent",
    value: function renderQualificationsContent() {
      var projectDetails = this.state.projectDetails;
      var priority = projectDetails.priority_expertise_tags || [];
      var nonPriority = projectDetails.non_priority_expertise_tags || [];
      if (priority.length === 0 && nonPriority.length === 0) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "review-tag-list"
      }, priority.map(function (label) {
        return /*#__PURE__*/React.createElement("span", {
          key: label,
          className: "review-tag review-tag--priority"
        }, label);
      }), nonPriority.map(function (label) {
        return /*#__PURE__*/React.createElement("span", {
          key: label,
          className: "review-tag"
        }, label);
      }));
    }
  }, {
    key: "renderBudgetLogisticsContent",
    value: function renderBudgetLogisticsContent() {
      var projectDetails = this.state.projectDetails;
      var min = projectDetails.budget_minimum,
        max = projectDetails.budget_maximum,
        empType = projectDetails.employment_type;
      var rateLabel = empType === 'full_time' ? 'Annual Base Salary' : 'Hourly Rate';
      var rateValue = function () {
        if (min == null || max == null) return null;
        var range = empType === 'full_time' ? "$".concat(Number(min).toLocaleString(), " - $").concat(Number(max).toLocaleString(), " / year") : "$".concat(min, " - $").concat(max, " /hour");
        var suffix = empType === 'full_time' ? projectDetails.base_pay_hidden ? ' (Hidden)' : '' : projectDetails.rate_negotiable ? ' (Negotiable)' : '';
        return "".concat(range).concat(suffix);
      }();
      return /*#__PURE__*/React.createElement("div", {
        className: "ps-info-list"
      }, /*#__PURE__*/React.createElement(InfoRow, {
        icon: "fa-dollar-sign",
        label: rateLabel,
        value: rateValue
      }), /*#__PURE__*/React.createElement(InfoRow, {
        icon: "fa-building",
        label: "Workplace Type",
        value: projectDetails.work_location
      }), projectDetails.remote_preferred_location && /*#__PURE__*/React.createElement(InfoRow, {
        icon: "fa-map-marker-alt",
        label: "Desired Candidate Location",
        value: projectDetails.remote_preferred_location
      }), /*#__PURE__*/React.createElement(InfoRow, {
        icon: "fa-map-marker-alt",
        label: "Location",
        value: projectDetails.office_and_worktype_information
      }), /*#__PURE__*/React.createElement(InfoRow, {
        icon: "fa-plane",
        label: "Travel Requirements",
        value: this.travelLocationText()
      }));
    }
  }, {
    key: "renderTeamContent",
    value: function renderTeamContent() {
      var _this6 = this;
      var csrfToken = this.props.csrfToken;
      var _this$state2 = this.state,
        projectDetails = _this$state2.projectDetails,
        openTeamModal = _this$state2.openTeamModal,
        pageSubmitted = _this$state2.pageSubmitted;
      var memberCount = projectDetails.initial_team_members.team_members.length;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "meta-row mb-2"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-user-friends",
        style: {
          color: '#818181'
        }
      }), "".concat(memberCount, " ").concat(memberCount === 1 ? 'member' : 'members'), /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: 0,
        className: "ms-3",
        style: {
          color: '#00bfa5',
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return _this6.setState({
            openTeamModal: true
          });
        }
      }, "+ Add interviewers")), /*#__PURE__*/React.createElement(AddCoworkersModal, {
        csrfToken: csrfToken,
        initialTeamMembers: projectDetails.initial_team_members,
        invitableRoles: projectDetails.invitable_roles,
        editableRoles: projectDetails.editable_roles,
        basePermissionsUrl: projectDetails.base_permissions_url,
        location: "project-review",
        showModalCallback: function showModalCallback() {
          return _this6.setState({
            teamModalViewed: true
          });
        },
        hideModalCallback: this.handleAfterPublish,
        modalIsOpen: openTeamModal,
        pageSubmitted: pageSubmitted
      }));
    }
  }, {
    key: "renderAdminContent",
    value: function renderAdminContent() {
      var _this$props3 = this.props,
        projectResourceId = _this$props3.projectResourceId,
        csrfToken = _this$props3.csrfToken,
        getProjectDetails = _this$props3.getProjectDetails,
        projectTypes = _this$props3.projectTypes,
        openAdminModal = _this$props3.openAdminModal;
      var _this$state3 = this.state,
        projectDetails = _this$state3.projectDetails,
        adminModalOpen = _this$state3.adminModalOpen;
      var dateString;
      if (projectDetails.approximate_start_date_local) {
        dateString = new Date("".concat(projectDetails.approximate_start_date_local, " 0:00")).toLocaleDateString();
      } else {
        dateString = 'ASAP';
      }
      return /*#__PURE__*/React.createElement("div", {
        id: "admin-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "mb-2"
      }, "".concat(projectDetails.project_type || '??', " \u2022 Starts ").concat(dateString, " \u2022 ").concat(processTakeRate(projectDetails.clora_take_rate) || '??', "%")), /*#__PURE__*/React.createElement(AdminModal, {
        formType: "modal-only",
        projectResourceId: projectResourceId,
        csrfToken: csrfToken,
        getProjectDetails: getProjectDetails,
        afterSubmit: this.updateProjectDetails,
        projectTypes: projectTypes,
        modalOpen: adminModalOpen || openAdminModal
      }));
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var errors = this.state.errors;
      if (!errors) return null;
      var errorList = Array.isArray(errors) ? errors : [String(errors)];
      if (errorList.length === 0) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "alert alert-danger",
        role: "alert"
      }, /*#__PURE__*/React.createElement("strong", null, "Errors prohibited this project from being submitted:"), /*#__PURE__*/React.createElement("ul", {
        className: "mb-0 mt-2"
      }, errorList.map(function (e) {
        return /*#__PURE__*/React.createElement("li", {
          key: e
        }, e);
      })));
    }
  }, {
    key: "renderConfirmProjectDeletion",
    value: function renderConfirmProjectDeletion() {
      var _this7 = this;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
        className: "btn-delete",
        onClick: function onClick() {
          return _this7.setState({
            showConfirmDeletion: true
          });
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-trash-alt"
      }), "Delete Project"), /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showConfirmDeletion,
        onHide: function onHide() {
          return _this7.setState({
            showConfirmDeletion: false
          });
        },
        id: "confirm-deletion-modal"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
        className: "confirm-deletion-modal-body style-guide"
      }, /*#__PURE__*/React.createElement("h2", null, "Are you sure you want to delete this project?"), /*#__PURE__*/React.createElement("div", {
        className: "confirm-actions"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-default",
        onClick: function onClick() {
          return _this7.setState({
            showConfirmDeletion: false
          });
        }
      }, "Back"), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-danger",
        onClick: this.handleDeleteProject
      }, "Delete Project"))))));
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var projectDetails = this.state.projectDetails;
      var deleteProjectPath = projectDetails.delete_project_path;
      var isDraft = this.isProjectDraft();
      return /*#__PURE__*/React.createElement("div", {
        className: "review-footer-bar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container review-footer-inner"
      }, deleteProjectPath && this.renderConfirmProjectDeletion(), isDraft && /*#__PURE__*/React.createElement("button", {
        className: "btn-draft",
        onClick: this.handleExit
      }, "Save as Draft"), this.renderSubmit()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;
      var _this$state4 = this.state,
        projectDetails = _this$state4.projectDetails,
        loading = _this$state4.loading;
      var _this$props4 = this.props,
        homePath = _this$props4.homePath,
        isAdmin = _this$props4.isAdmin;
      if (!projectDetails || loading) {
        return /*#__PURE__*/React.createElement(ProjectLoadingIndicator, null);
      }
      var empType = projectDetails.employment_type;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ProjectDetailsNav, {
        displayExit: false,
        homePath: homePath
      }), /*#__PURE__*/React.createElement("div", {
        className: "project-review-page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "review-header-card project-review-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "review-header-inner"
      }, /*#__PURE__*/React.createElement(FeaturedProfileBanner, {
        consultantName: projectDetails.status === 'employer_draft' && projectDetails.favorited_consultant ? projectDetails.favorited_consultant : null
      }), this.renderSubmit('header-submit-btn'))), this.renderErrors(), /*#__PURE__*/React.createElement("div", {
        className: "review-sections-list"
      }, this.renderSection('Job Title and Role', this.renderJobTitleContent(), 'start', 'Start'), empType === 'consulting' && this.renderSection('Length of Engagement', this.renderEngagementContent(), 'start', 'Start'), this.renderSection('About This Job', this.renderAboutContent(), 'description', 'Responsibilities'), this.renderSection('Ideal Candidate', this.renderIdealCandidateContent(), 'description', 'Responsibilities'), this.renderSection('Responsibilities', this.renderResponsibilitiesContent(), 'description', 'Responsibilities'), this.renderSection('Qualifications', this.renderQualificationsContent(), 'qualifications', 'Qualifications'), this.renderSection('Budget and Logistics', this.renderBudgetLogisticsContent(), 'budget & logistics', 'Budget & Logistics'), this.renderSection('Team', this.renderTeamContent(), null), isAdmin && this.renderSection('Admin', this.renderAdminContent(), null, null, function () {
        return _this8.setState({
          adminModalOpen: false
        }, function () {
          return _this8.setState({
            adminModalOpen: true
          });
        });
      })))), this.renderFooter());
    }
  }]);
}(Component);
ProjectReview.propTypes = {
  projectResourceId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  getProjectDetails: PropTypes.func.isRequired,
  handleUpdateSection: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  projectTypes: PropTypes.arrayOf(PropTypes.shape({})),
  isAdmin: PropTypes.bool,
  openAdminModal: PropTypes.bool,
  userId: PropTypes.string.isRequired,
  homePath: PropTypes.string.isRequired,
  showFullTimeOption: PropTypes.bool
};
ProjectReview.defaultProps = {
  projectResourceId: null,
  projectTypes: [],
  isAdmin: false,
  openAdminModal: false,
  showFullTimeOption: false
};
export default ProjectReview;